import axios from "axios";
import store from "./store";
axios.defaults.baseURL = store.state.host;
async function getPosts() {
  return await axios
    .get("/api/getPosts.php")
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function getAllPosts() {
  return await axios
    .get("/api/getAllPosts.php")
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function getUser() {
  return await axios
    .get("/api/getUser.php")
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function postPost(formdata) {
  return await axios
    .post("/api/postPost.php", formdata)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function deletePost(id) {
  return await axios
    .post("/api/deletePost.php?id=" + id)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function deleteMail(id) {
  return await axios
    .post("/api/deleteMail.php?id=" + id)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function getAllMailAddress() {
  return await axios
    .get("/api/getAllMailAddress.php")
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function postMailAddress(formdata) {
  return await axios
    .post("/api/postMailAddress.php", formdata)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function postMedia(formdata) {
  return await axios
    .post("/api/postMedia.php", formdata, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function getMedia(id) {
  return await axios
    .post("/api/getMedia.php?id=" + id)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function sendToLine(text) {
  return await axios
    .post("/api/send_active_all.php", {
      message: text,
    })
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function vacuum() {
  return await axios
    .post("/api/vacuum.php")
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function get_line_info() {
  return await axios
    .get("/api/get_line_info.php")
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function mailList_add(name, mail) {
  return await axios
    .post("/api/mailList_add.php", {
      name: name,
      mail: mail,
    })
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
async function safety_reset() {
  return await axios
    .post("/api/safety_reset.php")
    .then((response) => {
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
}
export default {
  getPosts,
  getAllPosts,
  getUser,
  postPost,
  deletePost,
  deleteMail,
  getAllMailAddress,
  postMailAddress,
  postMedia,
  getMedia,
  sendToLine,
  vacuum,
  get_line_info,
  mailList_add,
  safety_reset,
};
